import React, { useState } from 'react';
import { PrefabPickerField } from './PrefabPickerField';
import { PrefabPickerGrid } from './PrefabPickerGrid';
import { Prefab } from '@gift/basic-scene-core/Prefab';
import { useToggle } from '@gift/ui/hooks/useToggle';
import { Mobile } from '@gift/ui/components/breakpoints/Mobile';
import { ConfirmModal } from '@gift/ui/components/modal/ConfirmModal';

export const PrefabPickerModal = ({
    title, prefabs, selectedPrefab, commit
}: Props) => {

    const [isOpen, toggleIsOpen] = useToggle(false);
    const [localValue, setLocalValue] = useState(selectedPrefab);

    const cancel = () => {
        setLocalValue(selectedPrefab);
        toggleIsOpen();
    };

    const onConfirm = () => {
        commit(localValue);
        toggleIsOpen();
    };

    return (
        <Mobile>
            <PrefabPickerField title={title} onClick={toggleIsOpen} active={isOpen} />
            <ConfirmModal title={title} active={isOpen} onReject={cancel} onConfirm={onConfirm}>
                <PrefabPickerGrid prefabs={prefabs} selectedPrefab={localValue} commit={setLocalValue} />
            </ConfirmModal>
        </Mobile>
    );
};

type Props = {
    title: string,
    prefabs: Prefab[],
    selectedPrefab: Prefab,
    commit: (prefab: Prefab) => void
};